import classnames from 'classnames';
import React from 'react';
import styles from "./Spinner.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Spinner = ({
  size = 30,
  stroke = 3,
  color = styles.colorInteraction,
  className
}) => /*#__PURE__*/_jsx("div", {
  className: classnames(styles.spinner, className),
  children: /*#__PURE__*/_jsxs("svg", {
    height: size,
    width: size,
    viewBox: "0 0 30 30",
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "colorGradient",
      x1: "0",
      y1: "0",
      x2: "1",
      y2: "1",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0%",
        stopColor: color,
        stopOpacity: 0
      }), /*#__PURE__*/_jsx("stop", {
        offset: "100%",
        stopColor: color
      })]
    }), /*#__PURE__*/_jsx("circle", {
      cx: "15",
      cy: "15",
      r: "12",
      fill: "none",
      stroke: "url(#colorGradient)",
      strokeWidth: stroke
    })]
  })
});